// extracted by mini-css-extract-plugin
export default {"documentResults":"styles_documentResults__pClC6"};